import React from "react";
import { FormControl, InputLabel, Select, MenuItem, Box } from "@mui/material";

interface StatusFilterProps {
  value: boolean | "";
  onChange: (value: boolean | "") => void;
}

const StatusFilter: React.FC<StatusFilterProps> = ({
  value,
  onChange,
}) => {
  return (
    <Box sx={{ minWidth: 150 }}>
      <FormControl fullWidth size="small">
        <InputLabel>Status</InputLabel>

        <Select
          value={value}
          label="Status"
          onChange={(e) => {
            const val = e.target.value;

            if (val === "") {
              onChange("");
            } else {
              onChange(val === "true");
            }
          }}
        >
          <MenuItem value="">All</MenuItem>
          <MenuItem value="true">Active</MenuItem>
          <MenuItem value="false">Inactive</MenuItem>
        </Select>
      </FormControl>
    </Box>
  );
};

export default StatusFilter;